import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const n = e((o, r) => /* @__PURE__ */ s.jsx(
  i,
  {
    ref: r,
    ...o,
    image: (t) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...t,
        children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M24 40c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16m0-30.5C16 9.5 9.5 16 9.5 24S16 38.5 24 38.5 38.5 32 38.5 24 32 9.5 24 9.5"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M18.12 32.88a.7.7 0 0 1-.51-.21.755.755 0 0 1-.03-1.06c1.47-1.56 3.7-2.48 6.12-2.52 2.6-.06 5.03.86 6.71 2.5.3.29.3.76.01 1.06s-.76.3-1.06.01c-1.39-1.36-3.45-2.11-5.63-2.08-2.02.04-3.87.79-5.06 2.05-.15.17-.35.25-.55.25"
            }
          )
        ]
      }
    )
  }
));
n.displayName = "AgencyUnsatisfiedIcon";
export {
  n as AgencyUnsatisfiedIcon,
  n as default
};
//# sourceMappingURL=index.js.map
